/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Feldbergschule1Inputs */

const en__field_enum_feldbergschule1 = /** @type {(inputs: _Field_Enum_Feldbergschule1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oberursel`)
};

const de__field_enum_feldbergschule1 = /** @type {(inputs: _Field_Enum_Feldbergschule1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feldbergschule`)
};

/**
* | output |
* | --- |
* | "Oberursel" |
*
* @param {_Field_Enum_Feldbergschule1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_feldbergschule1 = /** @type {((inputs?: _Field_Enum_Feldbergschule1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Feldbergschule1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_feldbergschule1(inputs)
	return de__field_enum_feldbergschule1(inputs)
});
export { _field_enum_feldbergschule1 as "_field_enum_Feldbergschule" }